export default __webpack_public_path__ + "static/media/gallery_02.f02ca2c3.jpg";